import script from "./OrderPayment.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderPayment.vue?vue&type=script&setup=true&lang=ts"

import "./OrderPayment.vue?vue&type=style&index=0&id=c92fd52a&lang=css"

const __exports__ = script;

export default __exports__